export const locale = {
  lang: 'en-CA',
  data: {
    CREATE_COMBO_DYNAMIC: {
      TITLE: 'New dynamic combo',
      SELECT_TYPE: 'Select a product type',
      FOOD: 'Food',
      DRINK: 'Drink',
    },
  },
};
